import digitalData from 'digital-data';
import { getPageType, setAnalytics } from '../../../thd-analytics-utils';
import { NUCLEUS } from '../../../constants';

export function exchange() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('exchange.ready', ({ output = {} }) => {
    setAnalytics(digitalData);
    if (digitalData.site) {
      const allowedDomains = window.cookieUtils?.readBrowserCookie('allowed_domains');
      if (allowedDomains) {
        digitalData.site.integration = allowedDomains.toLowerCase();
      }
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('generic-4xx.load-exchange', ({ output = {} }) => {
    const pageType = getPageType();
    digitalData.page = {
      pageInfo: {
        pageLoadEvent: 'error',
        pageName: 'exchangeError',
        pageType,
        platform: NUCLEUS
      },
      error: [
        {
          displayType: 'page',
          pageSection: pageType,
          errorCode: '',
          message: 'This page is not available through this site.'
        }
      ]
    };
    setAnalytics(digitalData);
  });
}
